// extracted by mini-css-extract-plugin
export var container = "_da-0";
export var icon = "_da-1";
export var text = "_da-2";